// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"userAwards_wrapper_2LZJ5"};